import * as React from "react";
import { IconProps } from "./IconProps";

export const IconSolidChevronDown = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M1.20706 0C0.761605 0 0.538521 0.538571 0.853503 0.853553L5.6464 5.64645C5.84166 5.84171 6.15825 5.84171 6.35351 5.64645L11.1464 0.853553C11.4614 0.538571 11.2383 0 10.7929 0H1.20706Z"
          fill={color}
        />
      </svg>
    );
  },
);
